import { memo } from 'react';
import { isEqual } from 'lodash';
import { isDesktop } from 'react-device-detect';
import { Box, Divider, Stack, GlobalStyles, useMediaQuery, useTheme } from '@mui/material';
import {
  FlowResourceType,
  NavbarUserAccount,
  useEditorStore,
  NavbarWrapper,
  useIsOnline,
} from '@diana/core';
import { CloseIconButton } from '../../Components/CloseIconButton/CloseIconButton';
import { SaveStatusIndicator } from '../../Components/SaveStatusIndicator/SaveStatusIndicator';
import { FlowSettingsIconButton } from '../../Components/FlowSettingsIconButton/FlowSettingsIconButton';
import { HelpIconButton } from '../../Components/HelpIconButton/HelpIconButton';
import { ResetChangesIconButton } from '../../Components/ResetChangesIconButton/ResetChangesIconButton';
import { PublishButton } from '../../Components/PublishButton/PublishButton';
import { PreviewIconButton } from '../../Components/PreviewIconButton/PreviewIconButton';
import { BuilderSwitcher } from '../../Components/BuilderSwitcher/BuilderSwitcher';
import { LeftDrawerToggleButton } from '../../Components/LeftDrawerToggleButton/LeftDrawerToggleButton';

export const BuilderViewNavbar = memo(() => {
  const { breakpoints, spacing, palette } = useTheme();
  const isSmallDevice = useMediaQuery(breakpoints.down('lg'));
  const isOnline = useIsOnline();
  const minWidth = 360;

  const flowResourceType = useEditorStore((s) => s.flow?.properties.flowResourceType);
  const isPageBlocked = isSmallDevice || !isDesktop;

  return (
    <NavbarWrapper
      hideMainNavbar
      sx={{ backgroundColor: palette.background.paper, ...(isPageBlocked && { zIndex: 10000 }) }}
    >
      <GlobalStyles
        styles={{
          '.MuiTooltip-popper[data-popper-placement*="bottom"] .MuiTooltip-tooltip': {
            marginTop: spacing(0.5),
          },
        }}
      />
      <Stack
        direction="row"
        gap={2}
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Stack direction="row" alignItems="center" gap={0.5} sx={{ minWidth }}>
          <CloseIconButton />
          {isOnline && (
            <>
              <Divider orientation="vertical" sx={{ height: 16 }} />
              <LeftDrawerToggleButton />
            </>
          )}
        </Stack>
        <Box display={isPageBlocked || !isOnline ? 'none' : 'initial'}>
          <BuilderSwitcher />
        </Box>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          gap={1}
          display={isPageBlocked ? 'none' : 'flex'}
          sx={{ minWidth }}
        >
          {isOnline ? (
            flowResourceType === FlowResourceType.Entity ? (
              <>
                <SaveStatusIndicator />
                <FlowSettingsIconButton />
                <HelpIconButton />
                <ResetChangesIconButton />
                <PublishButton />
              </>
            ) : (
              <>
                <SaveStatusIndicator />
                <FlowSettingsIconButton />
                <HelpIconButton />
                <PreviewIconButton />
                <ResetChangesIconButton />
                <PublishButton />
              </>
            )
          ) : null}
          {isOnline && <Divider orientation="vertical" variant="middle" flexItem />}
          <NavbarUserAccount />
        </Stack>
      </Stack>
    </NavbarWrapper>
  );
}, isEqual);
